module.exports = __webpack_public_path__ + "img/613-42dfb3.png";